export default __webpack_public_path__ + "static/media/Star Touched Mantle of the Living Legend.78e26ff2.jpg";